import { jsx as _jsx } from "react/jsx-runtime";
import ivclass from '../../../../Modules/IVClass';
import SubMenu from './SubMenu';
import Drawer from '../Drawer';
const DropMenu = (props) => {
    const { showDropDown, platform, menu, menuName, position, os } = props;
    return (_jsx("div", { className: ivclass('iv-header-dropdown'), style: { opacity: showDropDown ? 1 : '' }, children: _jsx(Drawer, { leftPosition: `${position + 10}px`, padding: ivclass('iv-p-30'), layout: menu[menuName].layout, children: _jsx(SubMenu, { platform: platform, os: os, subMenu: menu[menuName], authFunctions: props.authFunctions }) }) }));
};
export default DropMenu;
